export default __webpack_public_path__ + "static/media/Pistol_6.5b6867a1.png";